import React from 'react';

export default function ArrowRightLong({ iconClass }: { iconClass?: string }) {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      aria-hidden="true"
      focusable="false"
      role="img"
      className={iconClass}
    >
      <path d="m601.4 337 17-17-17-17-136-136-17-17-33.9 33.9 17 17 95 95H32.4v48h494.1l-95 95-17 17 33.9 33.9 17-17 136-136z" />
    </svg>
  )
}
